import { Stack, Typography, Tooltip } from '@mui/material'
import React, { useMemo } from 'react'

import { getAttackDurationReadable } from 'components/attacks/utils/attacks'
import { formatFailureFlagExperimentDuration } from 'components/failure-flags/failure-flags-utils'
import {
  getCliArgs,
  getInfraCommandType
} from 'components/scenarios/concurrent/attack-attributes'
import { AttackNodeArguments } from 'components/scenarios/concurrent/AttackNodeArguments'
import { isFailureFlagNode } from 'components/scenarios/utils/graph/nodes/typeguards'
import useMetadata from 'hooks/use-metadata'
import { getMetaForDisplayableArgs } from 'utils/metadata'

import type {
  FailureFlagNode,
  InfraAttackNode
} from 'types/api/scenarios/scenario'

export const GraphNodeNameDuration: React.FC<{
  allInfraNodes?: InfraAttackNode[]
  node: InfraAttackNode | FailureFlagNode
}> = ({ allInfraNodes, node }) => {
  const { getAttackName, metadata } = useMetadata()

  const isFailureFlag = isFailureFlagNode(node)

  const allAttackArgs = useMemo(() => {
    return isFailureFlag
      ? undefined
      : allInfraNodes?.map((currentNode) => {
          const currentNodeCliArgs = getCliArgs(currentNode)
          return getMetaForDisplayableArgs(currentNodeCliArgs, metadata)
        })
  }, [allInfraNodes, isFailureFlag, metadata])

  const cliArgs = isFailureFlag ? undefined : getCliArgs(node)

  const name = isFailureFlag
    ? 'Failure Flag Impact'
    : getAttackName(getInfraCommandType(node))

  const duration = isFailureFlag
    ? formatFailureFlagExperimentDuration(
        node.failureFlagInputForScenario.duration
      )
    : getAttackDurationReadable(cliArgs)

  return (
    <Tooltip
      arrow
      placement="top"
      title={
        node.state?.failed_reason ??
        (allAttackArgs && cliArgs && (
          <AttackNodeArguments
            allAttackArgs={allAttackArgs}
            args={cliArgs}
            metadata={metadata}
          />
        ))
      }
    >
      <Stack>
        <Typography
          data-test-row-attack-type
          sx={{
            fontWeight: 'bold'
          }}
        >
          {name}
        </Typography>
        <Typography
          data-test-row-duration
          component="figure"
          variant="secondaryCaption"
        >
          {duration}
        </Typography>
      </Stack>
    </Tooltip>
  )
}
